module.exports = __webpack_public_path__ + "static/img/68081J_2_R_3_I_20191203_LC.d3f07e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/68081J_2_R_3_I_20191203_LC.png
// module id = fmxs
// module chunks = 0